import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-u1867",
  "use": "icon-u1867-usage",
  "viewBox": "0 0 751 2",
  "content": "<symbol xmlns:xlink=\"http://www.w3.org/1999/xlink\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 751 2\" id=\"icon-u1867\">\n  <g transform=\"matrix(1 0 0 1 0 -457 )\">\n    <path d=\"M 0 457.5  L 750 457.5  \" stroke-width=\"1\" stroke=\"#999999\" fill=\"none\" />\n  </g>\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol